import styled from 'styled-components';
import { breakpoint, sizes } from '../theme/breakpoint';
import { absoluteCenter, multiplyPx } from '../styled/utils';
import { Container } from '../styled/containers';
import { generateBackgroundImages } from '../styled/background-image';

const mobileHeroMinHeight = 180;
const tabletHeroMinHeight = 300;
const desktopHeroMinHeight = 450;
const desktopHeroWideMinHeight = 500;

const tabletCardMinWidth = 450;
const tabletCardPctWidth = 50;
const desktopCardPctWidth = 55;

const doublePx = multiplyPx(2);
const triplePx = multiplyPx(3);
const quadruplePx = multiplyPx(4);

const imageSizes = {
  tablet: [sizes.tablet],
  desktop: [sizes.desktop],
  desktopWide: [sizes.desktopWide],
};

export const HeroContainer = styled.div`
  ${breakpoint.tablet`
    margin-bottom: ${({ $removeMarginBottom, theme }) =>
      `${$removeMarginBottom ? 0 : theme.spacing.large}`};
    // NOTE: flex is required here for IE11 to honour the flex child min-height from .Hero
    display: flex;
  `}
`;

export const Hero = styled.section`
  width: 100vw;
  max-width: 100%;
  overflow: hidden;
  min-height: ${mobileHeroMinHeight}px;

  /* production process will munge separated BG rules incorrectly here  */
  background: ${({ $image, $alignImage }) =>
    $image &&
    `#f2f2f2
        center
        ${$alignImage === 'top' ? `top` : ''}
        ${$alignImage === 'middle' ? `center` : ''}
        ${$alignImage === 'bottom' ? `bottom` : ''}
        / cover no-repeat;`};
  ${({ $image: image }) =>
    image && generateBackgroundImages({ image, imageSizes, size: 'tablet' })};

  ${breakpoint.tablet`
    display: flex;
    min-height: ${tabletHeroMinHeight}px;
     ${({ $image: image }) =>
       image &&
       generateBackgroundImages({ image, imageSizes, size: 'desktop' })};
  `};

  ${breakpoint.desktop`
    min-height: ${desktopHeroMinHeight}px;
     ${({ $image: image }) =>
       image &&
       generateBackgroundImages({ image, imageSizes, size: 'desktopWide' })};
  `}

  ${breakpoint.desktopWide`
    min-height: ${desktopHeroWideMinHeight}px;
  `}
`;

// no-card
export const CenteredContent = styled.div`
  text-align: center;
  padding: 0 ${({ theme }) => theme.spacing.standard};
  color: ${({ $black, theme }) =>
    $black ? `${theme.palette.standardText}` : `${theme.palette.white}`};
`;

// standard
export const CardContent = styled.div`
  box-sizing: border-box;
  max-width: 60em;
  padding: ${({ theme }) =>
    `${theme.spacing.standard} ${theme.spacing.standard} ${theme.spacing.medium}`};
  background: #fff;

  ${breakpoint.tablet`
    width: ${tabletCardPctWidth}%;
    min-width: ${tabletCardMinWidth}px;
    margin-top: ${({ theme }) => doublePx(theme.spacing.medium)};
    margin-bottom: ${({ theme }) => triplePx(theme.spacing.medium)};
    margin-left: ${({ theme }) => theme.spacing.standard};
    margin-right: ${({ theme }) => theme.spacing.standard};
  `};

  ${breakpoint.desktop`
    width: ${desktopCardPctWidth}%;
  `};

  p {
    margin-bottom: ${({ theme }) => theme.spacing.standard};
  }
`;

// standard
export const ContentWrapper = styled(Container)`
  width: 100%;
  display: flex;
  padding: 0;

  ${breakpoint.tablet`
    align-self: center;
    ${({ $position }) => $position === 'left' && `justify-content: flex-start`};
    ${({ $position }) => $position === 'center' && `justify-content: center`};
    ${({ $position }) => $position === 'right' && `justify-content: flex-end`};

    ${({ $position, theme }) =>
      $position === 'bottom' &&
      `
      justify-content: center;
      align-self: flex-end;

      ${CardContent} {
        text-align: center;
        margin-top: ${quadruplePx(theme.spacing.large)};
        margin-bottom: ${theme.spacing.large};
        margin-left: 0;
        margin-right: 0;
      }`};
  `};
`;

// no-card
export const ContentWrapperNoCard = styled(ContentWrapper)`
  ${absoluteCenter}
  width: 100%;
  padding: 0;
`;

// standard, no-card
export const Title = styled.h1`
  margin-top: 0;
  margin-bottom: ${({ theme }) => theme.spacing.standard};
`;

//  no-card
export const Subtitle = styled.p`
  ${({ theme }) => theme.headers.h2};
  margin-bottom: 0;
`;

// standard
export const HideForMobile = styled.div`
  display: none;
  ${breakpoint.tablet`
    display: flex;
    width: 100%;
  `}
`;

// standard
export const HideAboveMobile = styled.div`
  display: block;
  ${breakpoint.tablet`
    display: none;
  `}
`;
